export const deductionCategories = {
  'statutoryWithholdings': {
    title: '1. Statutory (Mandated) Withholdings',
    subcategories: {
      'employee': {
        title: 'Employee',
        sections: {
          'federal': {
            title: 'A. Federal',
            fields: [
              'federalIncomeTax',
              'ssEmployee',
              'medicareEmployee', // correctly placed under 'employee'
              'additionalMedicareTax'
            ]
          },
          'state': {
            title: 'B. State',
            fields: [ 
              'stateIncomeTax',
              'stateDisabilityInsurance',
              'stateEmployeeUnemploymentInsurance'
            ]
          },
          'local': {
            title: 'C. Local',
            fields: [ 'localIncomeTax' ]
          },
          'other': {
            title: 'D. Other',
            fields: [ 'commuterTaxes' ]
          }
        }
      },
      'employer': {
        title: 'Employer',
        sections: {
          'federal': {
            title: 'A. Federal',
            fields: [
              'ssEmployer',
              'medicareEmployer', // correctly placed under 'employer'
              'federalUnemploymentTax'
            ]
          },
          'state': {
            title: 'B. State',
            fields: [
              'stateUnemploymentTax',
              'stateDisabilityFamilyLeave',
              'otherStateMandatedLeave'
            ]
          },
          'local': {
            title: 'C. Local',
            fields: [ 'localPayrollTaxes' ]
          },
          'other': {
            title: 'D. Other',
            fields: [
              'workersCompensation',
              'employerHealthCareMandatePenalties'
            ]
          }
        }
      }
    }
  },
  'voluntaryPreTaxDeductions': {
    title: '2. Voluntary Pre-Tax Deductions',
    subcategories: {
      'employee': {
        title: 'Employee',
        fields: [
          'retirementPlan',
          'healthInsurance',
          'healthSavingsAccount',
          'qualifiedTransportation',
          'groupLifeInsurance',
          'miscOthers'
        ]
      }
    }
  },
  'voluntaryAfterTaxDeductions': {
    title: '3. Voluntary After-Tax Deductions',
    subcategories: {
      'employee': {
        title: 'Employee',
        fields: [
          'roth401k',
          'additionalInsurance',
          'unionDues',
          'charitableContributions',
          'loanRepayments'
        ]
      }
    }
  }
};
